import {
    Flex,
    Stack,
  } from "@chakra-ui/react";
import { useState } from "react";
import { FiLock } from "react-icons/fi";
import { CreditCard } from "./_CreditCard";
import { useCreditCard } from "@/hooks/useCreditCard";
import BlockCreditCard from "../bloquear-cartao";
import { CreditCardInvoice } from "../fatura-cartao";
import { TrashIcon2 } from "@/styles/icons/TrashIcon2";
import DeleteCreditCard from "../deletar-cartao";
import { CreditCardName } from "../nome-cartao";
import { Button } from "barte-design-system";

  
  export default function CreditCardManagement() {
    const {
      creditCardData,
      selectedCreditCardName,
      creditCardLoading,
      currentCreditCardInvoiceDate
    } = useCreditCard();
    const [isDeleteCreditCardOpen, setIsDeleteCreditCardOpen] = useState(false);
    const [isBlockCreditCardOpen, setIsBlockCreditCardOpen] = useState(false);
    const featureTogglesUser = localStorage?.getItem("barte-features-list-user");
    const user = JSON.parse(localStorage.getItem("barte-user-info"));
    return (
      <>
        <BlockCreditCard
          isOpen={isBlockCreditCardOpen}
          onClose={() => setIsBlockCreditCardOpen(!isBlockCreditCardOpen)}
        />
        <DeleteCreditCard
          isOpen={isDeleteCreditCardOpen}
          onClose={() => setIsDeleteCreditCardOpen(!isDeleteCreditCardOpen)}
        />
        <Flex 
          w="100%"
          justifyContent="space-between"
          alignItems="center"
          gap={8}
        >
          <Flex 
              gap={4}
              alignItems="center"
              w="100%"
          >
              <CreditCard
                cardNumber={creditCardData?.panMasked}
                holderName={creditCardData?.cardName ?? selectedCreditCardName}
              />
              <Stack
                  spacing={6}
              >
                  {(user?.roles?.includes("BANKING_ADMIN") || user?.roles?.includes("BANKING_CARD")) && (
                    <>
                      <Button 
                        variant="outline" 
                        iconLeft={<FiLock color="currentColor" size={16} />}
                        onClick={() => setIsBlockCreditCardOpen(!isBlockCreditCardOpen)}
                        disabled={creditCardLoading || featureTogglesUser?.includes("block_items_credit_card")}
                      >
                        {creditCardData.cardStatus === "BLOCKED" ? "Desbloquear" : "Bloquear"}
                      </Button>
                      <Button 
                        variant="outline" 
                        iconLeft={<TrashIcon2 color="currentColor" size={16} />}
                        onClick={() => setIsDeleteCreditCardOpen(!isDeleteCreditCardOpen)}
                        disabled={creditCardLoading || featureTogglesUser?.includes("block_items_credit_card")}
                      >
                          Cancelar
                      </Button>
                    </>
                  )}
              </Stack>
          </Flex>
          <Flex
            maxW="400px"
            w="100%"
            gap={8}
            flexDirection="column"
          >
            <CreditCardName 
              name={selectedCreditCardName}
            />
            <CreditCardInvoice 
              availableLimit={0}
              currentBalance={0}
              usedPercentage={0}
              customHeight="90px"
              dueDate={currentCreditCardInvoiceDate.dueDate}
              nextClosingDate={currentCreditCardInvoiceDate.endDate}
              status={currentCreditCardInvoiceDate.status}
              isCurrentBalanceVisible={false}
            />
          </Flex>
        </Flex>
      </>
    );
  }
  